import { useContext } from "react";
import { Container } from "react-bootstrap";
import classes from "./OurServices.module.css";
import { MyContext } from "../../Context/MyContext";
import site from "../../data/site";
import RenderColService from "./RenderColService";

function OurServices() {
  const { serviceRef } = useContext(MyContext);

  return (
    <section ref={serviceRef} className="sectionShell" id="services">
      <Container>
        <div className={classes.intro}>
          <div className="sectionEyebrow">What we do</div>
          <h2 className="sectionTitle">Services built to win you customers</h2>
          <p className="sectionLead">
            Software, marketing, AI automations, and operational support —
            scoped to what your business needs next, not a generic package.
          </p>
        </div>
        <div className={classes.list}>
          {site.services.map((service, index) => (
            <RenderColService
              key={service.slug}
              image={service.image}
              imageAlt={service.imageAlt}
              width={service.width}
              height={service.height}
              title={service.title}
              hook={service.hook}
              deliverables={service.deliverables}
              bestFor={service.bestFor}
              href={`/services/${service.slug}`}
              reverse={index % 2 === 1}
            />
          ))}
        </div>
      </Container>
    </section>
  );
}

export default OurServices;
